import React from 'react';
import { Box, Flex } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import LockIcon from '@css-xp/base/assets/img/icon-lock.svg';
import { CommerceAddress } from '@css-xp/graphtypes/src/generated-types-new';

interface SoldToAddressDetailsWrapperProps {
  shipToAddress: CommerceAddress | undefined | null;
  isBillingProfileUsedForInternalUsageLicense: boolean;
  children: React.ReactElement;
}

export const SoldToAddressDetailsWrapper = ({
  shipToAddress,
  isBillingProfileUsedForInternalUsageLicense,
  children,
}: SoldToAddressDetailsWrapperProps): JSX.Element => {
  if (shipToAddress?.id) {
    return children;
  } else {
    return (
      <Flex>
        <p>Same as billing address</p>
        {isBillingProfileUsedForInternalUsageLicense && (
          <Box paddingInlineStart="space.050">
            <Tooltip
              content={
                "The sold-to address can't be changed as this billing profile is associated with internal usage licenses. For further assistance, please contact the Partner Service Desk."
              }
            >
              {/* @ts-ignore */}
              <img src={LockIcon} height={20} data-testid="lock-icon" />
            </Tooltip>
          </Box>
        )}
      </Flex>
    );
  }
};
